// ROW 1 — SMART OBJECT (Smart Tools epic, 2026-07-23). Morphs in whenever the
// single selection is a registered-recipe smart object (RibbonMount derives
// row1Kind 'smart' from the smartRecipeName mirror — shapeRow1's tucked-away
// smartEdit group was too easy to miss; owner: "once we have created a smart
// control, there is no way to reopen the options modal").
//
// This row is the seed of the RECIPE-DECLARED ribbon from the smart-tools
// plan (Theme | Colors | Font pair | Data | Edit…): recipes will extend it;
// today it carries the essentials — what's selected, THE options button, and
// flips (parity with shapes; smart objects are Groups).
const smartRow1 = {
  id: 'smart-row1',
  row: 1,
  groups: [
    {
      id: 'smartInfo',
      label: 'Selection',
      drawerSection: null,
      neverCollapse: true,
      controls: [
        // 'Bar chart' / 'Data table' … (the smartRecipeName mount mirror).
        { id: 'smartTypeLabel', kind: 'badge', label: 'Which tool is selected', read: 'smartRecipeName' },
      ],
    },
    {
      id: 'smartOptions',
      label: 'Tool',
      drawerSection: null,
      neverCollapse: true,
      controls: [
        // THE reopen affordance — opens the SmartToolModal in edit mode via
        // the existing ui.openSmartPanel handler (modal-first when a smart
        // object is selected).
        { id: 'smartOptionsOpen', kind: 'button', label: 'Open this tool’s options', icon: 'filters', text: 'Tool options…', handler: 'ui.openSmartPanel' },
      ],
    },
    {
      id: 'smartFlip',
      label: 'Flip',
      drawerSection: null,
      collapsePriority: 1,
      controls: [
        { id: 'smartFlipH', kind: 'button', label: 'Flip horizontal', icon: 'flipH', handler: 'object.flipH' },
        { id: 'smartFlipV', kind: 'button', label: 'Flip vertical', icon: 'flipV', handler: 'object.flipV' },
      ],
    },
  ],
};

export default smartRow1;
